/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type SlidePOST = {
    readonly id?: number;
    lab_id: number;
    lab_order_id?: number;
    specimen_id: number;
    block_obj_id: number;
    case_id: number;
    lab_station_id: number;
    stain_id: number;
    /**
     * industry name for the extracted 'case id' value. Should match Case.accession
     */
    accession_number?: string | null;
    lis_state?: SlidePOST.lis_state | null;
    /**
     * slide number in the provided block
     */
    slide_number?: string | null;
    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    status?: SlidePOST.status;
    readonly created_at?: string;
    readonly updated_at?: string;
    is_control?: boolean;
}

export namespace SlidePOST {

    export enum lis_state {
        UNSTAINED = 'unstained',
        RACKED = 'racked',
        STAINED = 'stained',
        SCANNING = 'scanning',
        SCANNED = 'scanned',
    }

    /**
     * status of a slide until it's fully imported and visible to a user in 'success'. History logged by SlideStatusChange.
     */
    export enum status {
        RECEIVED_WPL = 'received-wpl',
        RECEIVED_LAB = 'received-lab',
        PENDING = 'pending',
        PRECOMPUTING = 'precomputing',
        UPLOADED = 'uploaded',
        ERROR = 'error',
        MANUAL_MERGE = 'manual-merge',
        MANUAL_REVIEW = 'manual-review',
        SUCCESS = 'success',
        PENDING_AI = 'pending-ai',
        DELETED = 'deleted',
        ARCHIVED = 'archived',
        ON_HOLD = 'on-hold',
    }


}
